import { rest } from 'msw'
import { MerchantType } from 'types/types'
import mockMerchants from '../../../__mocks__/Merchants/merchants.json'

const getMerchantList = rest.get<MerchantType[]>(
  `${API_URL}/api/v1/merchant`,
  async (req, res, ctx) => {
    return res(ctx.json(mockMerchants))
  }
)

export default [getMerchantList]
